import { Link } from "react-router-dom";
import projects from "../Data/projects";

function ProjectsOverview() {
    return (
        <div id="background" className="bg-stone-300 min-h-screen w-full p-2 lg:p-6">
            <section
                id="full"
                className="bg-stone-50 rounded-lg shadow-md max-w-6xl mx-auto p-4 lg:p-10"
            >
                {/* Header */}
                <header className="text-center space-y-2 mb-6">
                    <h1 className="text-3xl sm:text-4xl font-bold text-stone-800">
                        My Projects
                    </h1>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        A selection of work I’ve done so far.
                    </p>
                </header>

                {/* Projects Grid */}
                <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
                    {projects.map((project) => (
                        <Link
                            key={project.id}
                            to={`/projects/${project.id}`}
                            className="block group"
                        >
                            <article className="bg-gradient-to-b from-[#ECE9E6] to-[#F7F5F3] rounded-2xl overflow-hidden shadow-md transition-transform duration-200 group-hover:-translate-y-1 group-hover:shadow-xl flex flex-col items-center justify-center text-center p-2 min-h-[28vh]">

                                {/* Smaller Icon */}
                                <div className="w-20 h-20 flex items-center justify-center rounded-lg bg-stone-100">
                                    <img
                                        src={project.thumbnail}
                                        alt={project.title}
                                        className="w-12 h-12 object-contain"
                                    />
                                </div>

                                {/* Title + Description */}
                                <h3 className="text-lg sm:text-xl font-semibold text-stone-800 group-hover:text-blue-600 transition-colors">
                                    {project.title}
                                </h3>
                                <p className="text-sm sm:text-base text-gray-600">
                                    {project.description}
                                </p>

                                {/* Tags */}
                                <div className="mt-4 flex flex-wrap justify-center gap-2">
                                    {project.tags?.map((tag, index) => (
                                        <span
                                            key={index}
                                            className="px-2 py-1 text-xs sm:text-sm bg-stone-200 text-stone-700 rounded-full"
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </article>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}

export default ProjectsOverview;
